import { Column, Icon, Row, Text } from "@amzn/meridian";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { COLORS } from "src/constants/colors";
import { useAppSelector } from "src/store/store";
import chevronLeftLargeTokens from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import { getInspectionWorkflow } from "src/store/workflowSlice";
import { useAppDispatch } from "src/store/store";
import WorkflowCard from "./workflowCard";

const ConfigurationDrivenInspections = () => {
  const { inspectionWorkflow } = useAppSelector((state) => state.workflow);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getInspectionWorkflow());
  }, []);

  return (
    <>
      <Column
        className="templates-page"
        height="100vh"
        alignmentVertical="justify"
        backgroundColor={COLORS.DARKER_WHITE}
      >
        <Column>
          <Column
            width="100%"
            backgroundColor={COLORS.WHITE}
            spacingInset="600 500 400"
          >
            <Row>
              <div
                style={{ cursor: "pointer", marginLeft: "50px" }}
                onClick={() => navigate("/")}
              >
                <Icon tokens={chevronLeftLargeTokens} color="primary" />
              </div>
              <Text type="h200">Dashboard</Text>
            </Row>
            <Column>
              <Row>
                <Text type="b500">Choose Inspection</Text>
              </Row>
            </Column>
          </Column>
          <Column spacingInset="none 500">
            {inspectionWorkflow !== null ?
              <WorkflowCard workflow={inspectionWorkflow} /> :
              <Text type="h100">
                There are no available inspection templates at the moment.
              </Text>}
          </Column>
        </Column>
      </Column>
    </>
  );
};

export default ConfigurationDrivenInspections;
